import * as Preact from "preact"
import PolygonClipping from "polygon-clipping"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"

import Dev from "@frog/source/models/dev/Dev.js"
import SequenceAnimation from "@frog/source/engine/animating/SequenceAnimation.js"

import Geometry from "@frog/source/utility/Geometry.js"
import Loop from "@frog/source/engine/Loop.js"
import Random from "@frog/source/utility/Random.js"
const random = new Random()
Math.clamp = function(min = 0, max = 1, value) {
    return Math.max(min, Math.min(max, value))
}

import Camera from "@frog/source/views/components/Camera.jsx"
import Cursor from "@frog/source/views/components/Cursor.jsx"
import Unit from "@frog/source/views/components/Unit.jsx"
import "@frog/source/views/Stage.less"

import EncounterArea from "@frog/source/views/components/EncounterArea.jsx"

export default class Stage {
    render() {
        return (
            <div class="Stage" phase={this.props.stage.player.phase}>
                <Camera chapter={App.game.chapter}>
                    <WorldImage stage={this.props.stage}/>
                    <Blocks stage={this.props.stage}/>
                    <Edges stage={this.props.stage}/>

                    <Units stage={this.props.stage}/>
                    <Particles stage={this.props.stage}/>

                    <Cursor stage={this.props.stage}/>
                    <ActionRange stage={this.props.stage}/>
                    <ActionArrow stage={this.props.stage}/>
                    <BloodlustRange stage={this.props.stage}/>

                    {Object.values(this.props.stage.encounters).map((encounter) => {
                        if(App.game?.configuration?.isRenderingEncounters) {
                            return (
                                <EncounterArea encounter={encounter}/>
                            )
                        }
                    })}
                    {Object.values(this.props.stage.world.spots).map((spot) => {
                        if(App.game?.configuration?.isRenderingSpots
                        && spot.hasCollision == true) {
                            return (
                                <div class="Spot" style={{
                                    "top": spot.position.y + "em",
                                    "left": spot.position.x + "em",
                                    "backgroundColor": "black",
                                    "z-index": 100,
                                }}/>
                            )
                        }
                    })}
                </Camera>
            </div>
        )
        // <Darkness stage={this.props.stage}/>
        // <Water stage={this.props.stage}/>
        // <Squiggles/>
        // <Spots stage={this.props.stage}/>
        // {Object.values(this.props.stage.encounters).map((encounter) => {
        //     if(App.game?.slug == "ember") {
        //         return (
        //             <EncounterArea encounter={encounter}/>
        //         )
        //     }
        // })}
        // {Object.values(this.props.stage.world.spots).map((spot) => {
        //     if(App.game?.slug == "ember"
        //     && spot.hasCollision == true) {
        //         return (
        //             <div class="Spot" style={{
        //                 "top": spot.position.y + "em",
        //                 "left": spot.position.x + "em",
        //                 "backgroundColor": "black",
        //                 "z-index": 100,
        //             }}/>
        //         )
        //     }
        // })}
    }
}

class Particles {
    render() {
        if(App.options.disableParticles == true) return
        if(this.props.stage.particles == undefined) return
        return Object.values(this.props.stage.particles).map((particle) => {
            if(particle.text != undefined) {
                return (
                    <div class="Particle" type={particle.stack || "damage"} style={{
                        "left": particle.position.x + "em",
                        "top": particle.position.y + "em",
                        "color": particle.color,
                        "opacity": particle.opacity,
                    }}>
                        <div class="Text">{particle.text?.string}</div>
                    </div>
                )
            } else if(particle.image != undefined) {
                return (
                    <div class="Particle" type="image" style={{
                        "left": particle.position.x + "em",
                        "top": particle.position.y + "em",
                        "background-image": "url(" + particle.image + ")",
                        "opacity": particle.opacity,
                    }}/>
                )
            }
        })
    }
}

function Edges() {
    if(this.props.stage.world.edges == undefined) return
    return Object.values(this.props.stage.world.edges).map((edge) => {
        if(edge.tilegid == 8) {
            return (
                <div class="Wall" style={{
                    "top": edge.position.y + "em",
                    "left": edge.position.x + "em",
                    "z-index": 100 + (edge.position.y * 10) + 1,
                }}/>
            )
        }
    })
}

function Blocks() {
    if(this.props.stage.world.blocks == undefined) return
    return (
        <div class="Blocks">
            {Object.values(this.props.stage.world.blocks).map((block) => {
                if(block.image != undefined) {
                    return (
                        <div class="Block" style={{
                            "top": block.position.y + "em",
                            "left": block.position.x + "em",
                            "backgroundImage": "url(" + block.image + ")",
                            "width": (block?.size?.x ?? 1) + "em",
                            "height": (block?.size?.y ?? 1) + "em",
                            "margin-top": -1 * ((block?.size?.y ?? 1) - 1) + "em",
                            "margin-left": -1 * ((block?.size?.x ?? 1) - 1) + "em",
                        }}/>
                    )
                }
            })}
        </div>
    )
}
//
// function Squiggles() {
//     const baseFrequency = "0.08"
//     return (
//         <svg display="none">
//             <defs>
//                 <filter id="squiggly-0">
//                     <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="0"/>
//                     <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
//                 </filter>
//                 <filter id="squiggly-1">
//                     <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="1"/>
//                     <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
//                 </filter>
//                 <filter id="squiggly-2">
//                     <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="2"/>
//                     <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
//                 </filter>
//                 <filter id="squiggly-3">
//                     <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="3"/>
//                     <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
//                 </filter>
//                 <filter id="squiggly-4">
//                     <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="4"/>
//                     <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
//                 </filter>
//             </defs>
//         </svg>
//     )
// }

// let flickering = 0.5
// function Darkness({stage}) {
//     if(stage.world == undefined) return
//     if(stage.currentEncounterKey == undefined) return
//
//     let points = [
//         "0em 0em",
//         "0em " + stage.world.height + "em",
//         stage.world.width + "em" + " " + stage.world.height + "em",
//         stage.world.width + "em" + " " + "0em",
//     ]
//
//     // const zone = stage.world.zones[stage.currentEncounterKey || "1"]
//
//     const darkness = stage.configuration?.darkness || App.game.configuration.darkness
//
//     if(darkness == "none") {
//         return
//     }
//
//     let polygons = []
//     if(darkness == false) {
//         const zone = stage.world.zones[stage.currentEncounterKey + "s"] || stage.world.zones[stage.currentEncounterKey]
//         if(zone.points != undefined) {
//             polygons.push([
//                 ...zone.points,
//                 zone.points[0]
//             ])
//         } else {
//             const x1 = zone.x
//             const y1 = zone.y
//             const x2 = zone.x + zone.width
//             const y2 = zone.y + zone.height
//             polygons.push([
//                 {"x": x1, "y": y1},
//                 {"x": x2, "y": y1},
//                 {"x": x2, "y": y2},
//                 {"x": x1, "y": y2},
//                 {"x": x1, "y": y1},
//             ])
//         }
//     }
//
//     if(darkness == true
//     || darkness == "night"
//     || darkness == "shadow") {
//         flickering = Math.clamp(-0.25, 0.25, flickering + random.range(-0.05, 0.05))
//         const flux = darkness == "night" ? flickering : 0
//
//         Object.values(stage.encounters).map((encounter) => {
//             // if(parseInt(zone.slug) > parseInt(stage.currentEncounterKey)) return
//             if(encounter.slug != stage.currentEncounterKey
//             && encounter.hasBeenSeen != true) {
//                 return
//             }
//             if(stage.encounters[encounter.key + "s"] != undefined) {
//                 encounter = stage.encounters[encounter.key + "s"]
//             }
//             const zone = encounter.zone
//             if(zone.points != undefined) {
//                 polygons.push([
//                     ...zone.points,
//                     zone.points[0]
//                 ].map((point, index) => {
//                     const vector = Geometry.multiply(point.internalAngle, flux)
//                     return Geometry.add(point, vector)
//                 }))
//             } else {
//                 const x1 = zone.x - flux
//                 const y1 = zone.y - flux
//                 const x2 = zone.x + zone.width + flux
//                 const y2 = zone.y + zone.height + flux
//                 polygons.push([
//                     {"x": x1, "y": y1},
//                     {"x": x2, "y": y1},
//                     {"x": x2, "y": y2},
//                     {"x": x1, "y": y2},
//                     {"x": x1, "y": y1},
//                 ])
//             }
//         })
//
//         if(polygons.length == 0) return
//
//         polygons = PolygonClipping.union(
//             ...polygons.map((polygon) => {
//                 const array = polygon.map((point) => {
//                     return [point.x, point.y]
//                 })
//                 return [array]
//             })
//         ).map((polygon) => {
//             polygon = polygon[0]
//             return polygon.map((point) => {
//                 return {"x": point[0], "y": point[1]}
//             })
//         })
//     }
//
//     polygons.forEach((polygon) => {
//         polygon.unshift({"x": 0, "y": 0})
//     })
//     polygons = polygons.map((polygon) => {
//         return polygon.map((point) => emify(point))
//     })
//     polygons.forEach((polygon) => {
//         points = points.concat(polygon)
//     })
//
//     return (
//         <div class="Darkness" type={darkness} style={{
//             "width": stage.world.width + "em",
//             "height": stage.world.height + "em",
//             // "top": (stage.imageOffset?.y || 0) + "em",
//             // "left": (stage.imageOffset?.x || 0) + "em",
//             "clip-path": "polygon(" + points.join(", ") + ")",
//         }}/>
//     )
// }
// function emify(point) {
//     return point.x + "em" + " " + point.y + "em"
// }

const ARROW_IMAGES = {
    "north-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-end.png"),
    "north-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-start.png"),
    "south-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-end.png"),
    "south-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-start.png"),
    "east-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-end.png"),
    "east-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-start.png"),
    "west-end": require("@frog/source/assets/images/hero-tactics-ii/arrow/west-end.png"),
    "west-start": require("@frog/source/assets/images/hero-tactics-ii/arrow/west-start.png"),
    "north-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-west.png"),
    "north-east": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
    "south-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-west.png"),
    "south-east": require("@frog/source/assets/images/hero-tactics-ii/arrow/south-east.png"),
    "east-west": require("@frog/source/assets/images/hero-tactics-ii/arrow/east-west.png"),
    "north-south": require("@frog/source/assets/images/hero-tactics-ii/arrow/north-south.png"),
}

class ActionArrow {
    render() {
        if(Dev.inProtoMode) return
        if(App.options.disableActionUI == true) return
        if(App.sequence != undefined
        && App.sequence?.steps?.length > 0) {
            return
        }

        return [this.move, this.attack]
    }
    get attack() {
        const action = App.game.chapter.selection.hoveredAction
        if(action == undefined) return

        if(action.type == "invoke skill") {
            const previousPosition = action.positions[1]
            const direction = Geometry.direction(action.positions[0], action.positions[1])
            const position = Geometry.add(action.positions[1], Geometry.multiply(direction, 0.5))

            return (
                <div class="AttackArrow" role={action.role} style={{
                    "top": position.y + "em",
                    "left": position.x + "em",
                }}/>
            )
        }
    }
    get move() {
        const action = App.game.chapter.selection.hoveredAction
        if(action == undefined) return

        const positions = action.positions.filter((position) => {
            return position.type == "wait"
                || position.type == "move"
                || position.type == "move through"
        })

        positions.forEach((position, index) => {
            const previousPosition = positions[index - 1]
            const nextPosition = positions[index + 1]
            const currentPosition = positions[index]

            let previousDirection = Geometry.name(Geometry.difference(previousPosition, currentPosition))
            let nextDirection = Geometry.name(Geometry.difference(nextPosition, currentPosition))

            if(previousPosition == undefined) previousDirection = "end"
            if(nextPosition == undefined) nextDirection = "start"

            position.image = ARROW_IMAGES[previousDirection + "-" + nextDirection] || ARROW_IMAGES[nextDirection + "-" + previousDirection]
        })

        return (
            <div class="MoveArrow">
                {positions.map((position) => (
                    <div class="Move" style={{
                        "left": position.x + "em",
                        "top": position.y + "em",
                        "background-image": position.image && "url(" + position.image + ")"
                    }}/>
                ))}
            </div>
        )
    }
}
function getAngleBetweenPoints(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI
}

class WorldImage {
    render() {
        if(this.props.stage.images == undefined
        && this.props.stage.image != undefined) {
            this.props.stage.images = [this.props.stage.image]
        }
        if(this.props.stage.images == undefined) return
        const currentEncounter = this.props.stage.encounters[this.props.stage.currentEncounterKey]
        return this.props.stage.images.map((image, index) => {
            return (
                <div class="WorldImage" style={{
                    "background-image": "url(" + (image.url || image) + ")",
                    "width": (image.width ?? this.props.stage.world.width ?? 16) + "em",
                    "height": (image.height ?? this.props.stage.world.height ?? 9) + "em",
                    "top": (image.y ?? 0) + "em",
                    "left": (image.x ?? 0) + "em",
                    // "animationName": (App.game?.configuration?.squigglevision == "world" && index != 0 ? "squigglevision" : ""),
                    "z-index": image.z ?? 0, // 1 + (index * 10) + ((image.z - currentEncounter.z) * 100),
                    "mix-blend-mode": image.effect,
                    "opacity": image.isFaded instanceof Function && image.isFaded(this.props.stage) == true ? 0.75 : 1,
                    "display": image.isHidden instanceof Function && image.isHidden(this.props.stage) == true ? "none" : "block",
                }}/>
            )
        })
    }
    get encounters() {
        if(this.props.stage.encounters == undefined) return
        return Object.values(this.props.stage.encounters).map((encounter) => {
            if(this.props.stage.currentEncounterKey < encounter.slug) return
            if(encounter.color == undefined) return
            return (
                <div class="EncounterImage" style={{
                    "width": encounter.width + "em",
                    "height": encounter.height + "em",
                    "left": encounter.x + "em",
                    "top": encounter.y + "em",
                    "backgroundColor": encounter.color,
                }}/>
            )
        })
    }
}

class Units {
    render() {
        const stage = this.props.stage
        return Object.values(stage.units).map((unit, index) => {
            if(unit == undefined) return
            if(unit.isDead == true) return
            if(unit.isRemoved == true) return
            if(unit.isNotRendered) return

            const roundedPosition = {
                "x": Math.round(unit.position.x),
                "y": Math.round(unit.position.y),
                "z": Math.round(unit.position.z)
            }

            if((stage.configuration?.darkness != "none"
            || App.game.configuration.encounterViewOnly == true)
            && stage.flags["ShowAllTheGuys"] != true) { // for pirates
                if(stage.currentEncounterKey != undefined
                && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, roundedPosition) == false) {
                    return
                }
            }

            let omegaunit = undefined
            if(SequenceAnimation.isPerforming != true
            && App.game.chapter?.selection?.hoveredAction?.omegastage?.units[unit.key] != undefined) {
                omegaunit = App.game.chapter.selection.hoveredAction.omegastage.units[unit.key]
            }

            return <Unit stage={stage} unit={unit} omegaunit={omegaunit} index={index}/>
        })
    }
}

class ActionRange {
    render() {
        if(App.options.disableActionUI == true) return
        // if(App.game.chapter.phase != "play") return
        if(App.sequence != undefined
        && App.sequence?.steps?.length > 0) {
            return
        }

        if(App.game.chapter.selection.selectedUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.selectedUnitKey]}/>
            )
        }

        if(App.game.chapter.selection.hoveredUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.hoveredUnitKey]}/>
            )
        }
    }
}
class BloodlustRange {
    render() {
        // if(App.game.chapter.phase != "play") return
        if(App.game.configuration.renderBloodlust != true) return

        const stage = this.props.stage || App.game.chapter.stage
        if(stage == undefined) return

        return Object.values(stage.units).map((unit) => {
            if(unit.spotTag == "warning") {
                return <UnitActionRange stage={stage} unit={unit} isBloodlust={true}/>
            }
        })
    }
}

class UnitActionRange {
    render() {
        const unit = this.props.unit
        const stage = this.props.stage

        if(unit == undefined) return
        if(unit.isDead == true) return

        let actionmap = unit.actionmap
        if(stage.nextTurn != undefined
        && stage.nextTurn.aiActions != undefined
        && stage.nextTurn.aiActions[unit.key] != undefined
        && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        }
        if(actionmap == undefined) {
            actionmap = App.game.chapter.stage.units[unit.key]?.actionmap
        }
        if(actionmap == undefined) {
            return
        }

        return Object.values(actionmap).map((actionlist, positionKey) => {
            const action = App.game.chapter.selection.findActionInActionlist({unit, actionlist})
            if(action == undefined) return
            return <UnitActionRangeTile stage={this.props.stage} unit={this.props.unit} action={action} isBloodlust={this.props.isBloodlust}/>
        })
    }
}

import World from "@frog/source/models/World.js"
class UnitActionRangeTile {
    render() {
        const tileKey = this.props.unit.key + "/" + this.props.action.position.x + "x" + this.props.action.position.y + "/" + Math.ceil(this.props.stage.turn.number / 2)
        return (
            <div class="UnitActionRangeTile" style={this.style} isBloodlust={this.props.isBloodlust} key={tileKey}>
                <div class="Sprite" type={this.type} style={this.spritestyle} key={tileKey}/>
            </div>
        )
    }
    get style() {
        // const terrain = World.getTerrain(this.props.stage.world, this.props.action.position)
        // if(terrain == undefined) return
        return {
            "left": this.props.action.position.x + "em",
            "top": this.props.action.position.y + "em",
            "opacity": App.game.chapter.selection.selectedUnitKey == this.props.unit.key ? 0.75 : 0.5,
        }
    }
    // get spritestyle() {
    //     return {
    //         "animation-delay": (1 + Geometry.distance(this.props.unit.position, this.props.action.position) / 2) + "s",
    //     }
    // }
    get type() {
        if(this.props.stage.units[this.props.action.performerKey].affiliation != this.props.stage.player.affiliation) {
            return "enemy action"
        }
        if(this.props.action.type == "invoke skill"
        && (this.props.action.role == "support" || this.props.action.role == "reposition")) {
            return "support action"
        }
        return this.props.action.type
    }
}
